import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';

@Directive({
  selector: '[appPasswordValidator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: PasswordValidatorDirective, multi: true }],
  standalone: false,
})
export class PasswordValidatorDirective implements Validator {
  public lowercaseRegex: RegExp = new RegExp('(?=.*[a-z])');
  public uppercaseRegex: RegExp = new RegExp('(?=.*[A-Z])');
  public specialcharRegex: RegExp = new RegExp('[!@#$%^&*(),.?":{}|<>]');
  public numRegex: RegExp = new RegExp('(?=.*\\d)');

  constructor() {}

  public validate(ctrl: AbstractControl): { [key: string]: boolean } {
    let password = ctrl.value;

    if (!this.isPasswordValid(password)) {
      return { invalidPassword: true };
    } else {
      return { invalidPassword: false };
    }
  }

  public isPasswordValid(password: string): boolean {
    let hasLower = false;
    let hasUpper = false;
    let hasSpecial = false;

    // has at least one lowercase letter
    if (this.lowercaseRegex.test(password)) {
      hasLower = true;
    }

    //has at least one uppercase letter
    if (this.uppercaseRegex.test(password)) {
      hasUpper = true;
    }

    // has at least one special character
    if (this.specialcharRegex.test(password)) {
      hasSpecial = true;
    }

    return hasLower && hasUpper && hasSpecial;
  }
}
